// extracted by mini-css-extract-plugin
export default {"messageWrapper":"Message_messageWrapper__T3m1-","withTriangle":"Message_withTriangle__f4jxZ"};